module.exports = "<div class=\"stepperInput\">\n  <button class=\"button button--addOnLeft\">-</button>\n  <input type=\"text\" placeholder=\"Age\" value=\"32\" class=\"input stepperInput__input\"/>\n  <button class=\"button button--addOnRight\">+</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/cjcenizal/Documents/GitHub/Mine/flexbox-patterns-site/node_modules/raw-loader!/Users/cjcenizal/Documents/GitHub/Mine/flexbox-patterns-site/node_modules/flexbox-patterns/src/examples/stepper-input.html
// module id = 781
// module chunks = 0